<script lang="ts">
  import { get, writable } from "svelte/store";
  import CompanyDropdown from "../../components/Business/CompanyDropdown.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import Table from "../../components/Table/Table.svelte";
  import type { ICompanyContact } from "../../entities";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { contactCompanyDtoFields } from "../../utils/TableFields/contact-company-dto.fields";
  import {
    companyContact,
    contactCompanies,
    loadCompanies,
    onDeleteCompanyContact,
    saveCompanyContact,
  } from "./contact.store";

  const editing = writable<boolean>(false);

  $: isNew = $companyContact != null && $companyContact.oid == 0;
  $: canSubmit =
    $companyContact != null &&
    $companyContact.companyId != 0 &&
    $companyContact.contactId != 0;

  async function onSubmit() {
    let _record = get(companyContact);
    let _resp: IApiResponse<ICompanyContact> = await saveCompanyContact(
      _record
    );
    onCancel();
    loadCompanies(_resp.payload.contactId);
  }

  function onCancel() {
    editing.set(false);
    companyContact.set({} as ICompanyContact);
  }

  function onCreate() {
    let item = {
      oid: 0,
      mainCompany: 0,
    } as ICompanyContact;
    onEdit(item);
  }

  function onEdit(item: ICompanyContact) {
    companyContact.set(Object.assign({}, item));
    editing.set(true);
  }
</script>

{#if $editing === false}
  <Table
    loading={false}
    fields={contactCompanyDtoFields}
    records={$contactCompanies}
    pagination={null}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail.companyContact)}
    on:delete={(e) => onDeleteCompanyContact(e.detail)}
  />
{:else if $companyContact}
  <div class="columns">
    <div class="column is-12">
      <FormLayout
        {canSubmit}
        {isNew}
        createButtonText="Associa"
        on:submit={onSubmit}
        on:cancel={onCancel}
      >
        <div class="columns">
          <div class="column is-6">
            <FormField>
              <CompanyDropdown
                required={true}
                bind:value={$companyContact.companyId}
              />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Switch
                name="Organizzazione Principale"
                bind:value={$companyContact.mainCompany}
              />
            </FormField>
          </div>
        </div>
        <div  class="columns">
          <div class="column is-6">
            <FormField>
              <ClfDropdown
                name="Carica"
                schema="JBPOSITION"
                required={false}
                clearVisible={true}
                bind:value={$companyContact.clfJobPositionId}
              />
            </FormField>
          </div>

          <div class="column is-6">
            <FormField>
              <ClfDropdown
                name="Ruolo"
                schema="JBROLEXXXX"
                required={false}
                clearVisible={true}
                bind:value={$companyContact.clfJobRoleId}
              />
            </FormField>
          </div>
        </div>
      </FormLayout>
    </div>
  </div>
{/if}
